import { useMe } from "@auth/useMe"
import { createFileRoute } from "@tanstack/react-router"
import { HStack, Text } from "@ui"

const RouteComponent = () => {
  const me = useMe()

  return (
    <HStack>
      <Text variant="h1">Hello, {me.firstName}</Text>
    </HStack>
  )
}

export const Route = createFileRoute("/_chrome/")({
  component: RouteComponent,
})
